// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__MyVjK","buttons":"PendingPaymentAlert_buttons__20xl2"};